<template>
  <div class="coupon-payment">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="search-line">
<!--      <div class="btn-box"></div>-->
      <div style="display: flex;justify-content: flex-end;">
        <span style="display: inline-block;color: #48576a;font-size: 14px;line-height: 30px;margin-right: 5px;">付费时间</span>
        <el-date-picker v-model="timevalue" size="small" type="datetimerange" range-separator="至"
                        start-placeholder="开始日期" end-placeholder="结束日期"
                        align="right" value-format="yyyy-MM-dd HH:mm:ss">
        </el-date-picker>
        <input-select :selectTitle="'付费状态'" style="margin-left: 10px;" :selectData="payStatusList" @search="search" :selectKey="'status'" />
      </div>
      <div style="display: flex;justify-content: space-between">
      </div>

      <div style="display: flex;justify-content: flex-end;">
      <input-search placeholder="商户名称/优惠券名称" @search="searchKey" />
        <button-export
          style="margin-left: 5px"
          :href="exportUrl"
          download="download.xls"
          :beforeDownload="beforeDownload"
          v-if="permissionCodes.indexOf('004035001') !== -1"
          value="导出"/>
        </div>
    </div>
    <table-main :selection="false" :tableHead="tableHead" :tableData="tableData" @changeSelection="changeSelection" :total="total" :pageNum="pageNum" :pageSize="pageSize" @changePagination="changePagination" :hasOperation="false" @seeExample="seeExample"/>


    <el-dialog title="优惠券详情" :visible.sync="dialogVisible" width="25%">
      <div>
        <div class="detail-item">
          <div>优惠券名称</div>
          <div>{{detailData.couponName}}</div>
        </div>
        <div class="detail-item">
          <div>优惠券类型</div>
          <div>{{detailData.couponType}}</div>
        </div>
        <div class="detail-item">
          <div>优惠券张数</div>
          <div>{{detailData.couponNum}}</div>
        </div>
        <div class="detail-item">
          <div>优惠券售价(元)</div>
          <div>{{detailData.couponPrice}}</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="small" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import ButtonDelete from "../../../components/Button/ButtonDelete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import InputSearch from "../../../components/Input/InputSearch";
import InputSelect from "../../../components/Input/InputSelect";
import TableMain from "../../../components/Table/TableMain";
import { api } from "../../api/ParkingService";
import { errorHandler } from "../../../utils/errorHandler";
import { bus } from "../../../utils/bus";

export default {
  components: {
    TableMain,
    InputSelect,
    InputSearch,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    Breadcrumb
  },
  name: "coupon-pay-record",
  data() {
    return {
      breadcrumb: [
        {
          value: "智慧停车",
          name: "amount-allocation"
        },
        {
          value: "优惠券缴费"
        }
      ],
      permissionCodes: '',
      // addCustom: 'amount-add',
      exportUrl: "",
      payStatusList: [
        {key: "", label: "全部"},
        {key: "0", label: "未缴费"},
        {key: "1", label: "已缴费"}
      ],
      tableHead: [
        {
          prop: "enterpriseName",
          label: "商户名称"
        },
        {
          prop: "couponName",
          label: "优惠券名称"
        },
        {
          prop: "coupon",
          label: "优惠券详情",
          example: true
        },
        {
          prop: "consumeTime",
          label: "出售时间"
        },
        {
          prop: "saleNum",
          label: "出售份数"
        },
        {
          prop: "money",
          label: "出售总金额(元)"
        },
        {
          prop: "saleTotalNum",
          label: "出售总张数"
        },
        {
          prop: "statusText",
          label: "付费状态"
        },
        {
          prop: "createTime",
          label: "付费时间"
        },
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],
      requestData: {
        searchKey: "",
        paymentMethod: "",
        status: ""
      },
      timevalue: [],

      dialogVisible:false,
      detailData:[]
    };
  },
  created() {
    this.getCreateTime();
    this.permissionCodes = bus.global.permissionCodes;
  },
  activated() {
    this.getCreateTime();
  },
  methods: {
    beforeDownload() {
      this.exportUrl = `${api.exportConsumptionRecordForParkingCoupon}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}&paymentMethod=${this.requestData.paymentMethod}&status=${this.requestData.status}&startTime=${this.requestData.startTime}&endTime=${this.requestData.endTime}`;
    },
    getCreateTime() {
      this.timevalue = [];
      let nowDate = new Date();
      let year = nowDate.getFullYear();
      let month =
        nowDate.getMonth() + 1 < 10
          ? "0" + (nowDate.getMonth() + 1)
          : nowDate.getMonth() + 1;
      let date =
        nowDate.getDate() < 10 ? "0" + nowDate.getDate() : nowDate.getDate();
      let hour =
        nowDate.getHours() < 10 ? "0" + nowDate.getHours() : nowDate.getHours();
      let minute =
        nowDate.getMinutes() < 10
          ? "0" + nowDate.getMinutes()
          : nowDate.getMinutes();
      let second =
        nowDate.getSeconds() < 10
          ? "0" + nowDate.getSeconds()
          : nowDate.getSeconds();
      this.timevalue[0] = year + "-" + month + "-" + date + " " + "00:00:00";
      this.timevalue[1] = year + "-" + month + "-" + date + " " + "23:59:59";
      this.getPage();
    },
    getPage() {
      if (this.timevalue) {
        this.requestData.startTime = this.timevalue[0];
        this.requestData.endTime = this.timevalue[1];
      } else {
        this.requestData.startTime = "";
        this.requestData.endTime = "";
      }
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      this.$axios.post(api.getConsumptionRecordForParkingCouponPage, reqData)
        .then(res => {
          if (res.data.retCode == 1) {
            let data = res.data.data.list;
            data.map(v => {
              if (v.consumeTime) {
                v.consumeTime = v.consumeTime.slice(0, 19);
              }
              if (v.status === "0") {
                v.statusText = "未缴费";
              } else if (v.status === "1") {
                v.statusText = "已缴费";
              }
            });
            this.total = res.data.data.total;
            this.tableData = data;
          }
        })
        .catch(errorHandler("获取记录失败"));
    },
    searchKey(v) {
      this.pageNum = 1;
      this.requestData.searchKey = v;
      this.getPage();
    },
    search(v) {
      this.pageNum = 1;
      this.requestData[v.key] = v.value;
      this.getPage();
    },
    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getPage();
    },
    changeSelection(codeArr) {
      this.selectionArr = codeArr;
    },

    seeExample(data){
      this.detailData=data;
      this.dialogVisible = true;
    },
  },
  watch: {
    timevalue(val) {
      this.getPage();
    }
  }
};
</script>

<style scoped>
.search-line {
  display: flex;
  justify-content: space-between;
  margin: 20px 0;
}
.btn-box {
  display: flex;
  justify-content: flex-start;
}
</style>

<style lang="less">
.el-input--small .el-input__inner {
  line-height: 30px;
}
.coupon-payment {
  .detail-item{
    display: flex;
    justify-content:space-between;
    align-items: center;
    margin: 10px 20px;
    font-size:14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/ParkingService/ParkingPayRecord/CouponPayment.vue